<template>
  <Section
    decoration="/images/circles.svg"
    :index="3"
    :title="t('sections.education')"
    id="education"
  >
    <ul>
      <Litem>
        <template v-slot:presentation>
          <p class="education__year">
            {{ education.year }}
          </p>
        </template>
        <template v-slot:content>
          <p class="education__institution">
            {{ education.institution }}
          </p>
          <p class="education__details">
            <span class="education__field">
              {{ education.field }}
            </span>
            <span class="education__degree">
              {{ education.degree }}
            </span>
          </p>
        </template>
      </Litem>
    </ul>
  </Section>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

import Litem from '@/ui/Litem.vue';
import Section from '@/ui/Section.vue';

type Education = {
  institution: string;
  year: string;
  degree: string;
  field: string;
};

const { t, tm } = useI18n();

const education = computed<Education>(() => tm('education'));
</script>

<style lang="scss" scoped>
@use '@/styles/mixins';
@use '@/styles/screens';

.education__year {
  margin-right: 32px;
  text-align: left;

  @include mixins.monotext;

  @include screens.tablet {
    text-align: right;
  }
}

.education__institution {
  color: var(--color-text-strong);
  font-family: var(--font-family-display);
  font-weight: 500;
  font-size: 24px;
  margin-bottom: 16px;
}

.education__details {
  display: flex;
  flex-direction: column;
  align-items: baseline;
  gap: 8px;

  @include screens.desktop {
    flex-direction: row;
    text-align: right;
  }
}

.education__field {
  font-size: 20px;
}

.education__degree {
  font-size: 14px;
}
</style>
